import { render, staticRenderFns } from "./ursLoginPanel.vue?vue&type=template&id=a6232158&scoped=true"
import script from "./ursLoginPanel.vue?vue&type=script&lang=js"
export * from "./ursLoginPanel.vue?vue&type=script&lang=js"
import style0 from "./ursLoginPanel.vue?vue&type=style&index=0&id=a6232158&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6232158",
  null
  
)

export default component.exports